import React from 'react';
import './PhoneMockup.css';

const PhoneMockup = ({ children, statusLabel, className = '' }) => {
  const now = new Date();
  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');

  return (
    <div className={`phone-mockup ${className}`.trim()}>
      <div className="phone-frame">
        <div className="phone-side-btn phone-side-btn-left-1" aria-hidden="true" />
        <div className="phone-side-btn phone-side-btn-left-2" aria-hidden="true" />
        <div className="phone-side-btn phone-side-btn-left-3" aria-hidden="true" />
        <div className="phone-side-btn phone-side-btn-right-1" aria-hidden="true" />

        <div className="phone-screen">
          <div className="phone-notch" aria-hidden="true">
            <div className="phone-notch-camera" />
          </div>

          <div className="phone-statusbar" aria-hidden="true">
            <span className="phone-statusbar-time">{`${hh}:${mm}`}</span>
            <span className="phone-statusbar-right">
              <span className="phone-statusbar-signal" />
              <span className="phone-statusbar-wifi" />
              <span className="phone-statusbar-battery" />
            </span>
          </div>

          <div className="phone-content">
            {children}
          </div>

          <div className="phone-home-indicator" aria-hidden="true" />
        </div>

        {statusLabel && (
          <div className="phone-status-label">{statusLabel}</div>
        )}
      </div>
    </div>
  );
};

export default PhoneMockup;
